import React, { useState, useEffect } from "react";
import red from "@material-ui/core/colors/red";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import { API_BASE_URL } from "../../constants";
import axios from "axios";
import jwt_decode from "jwt-decode";
import qs from "qs";
import { withRouter } from "react-router-dom";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://material-ui.com/">
        SML Group Limited
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const SignIn = (props) => {
  const classes = useStyles();

  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const handlePassword = (text) => {
    setPassword(text);
    setError(false);
  };

  const handleEmail = (text) => {
    setEmail(text);
    setError(false);
  };

  const handleSubmit = async () => {
    if (!email) {
      setError(true);
      setMessage("Email required");
    } else if (!password) {
      setError(true);
      setMessage("Password required");
    } else {
      setIsLoading(true);

      await axios
        .post(
          API_BASE_URL + "login",
          {
            email: email,
            password: password,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log("response", response);
          if (response && response.data.Payload) {
            setIsLoading(false);
            var decoded = jwt_decode(response.data.Payload);

            // User object
            let authUser = {
              email: decoded.email,
              name: decoded.name,
              role: decoded.resource_access["puma-mobileapi-service"][
                "roles"
              ][0],
            };

            if (authUser.role === "admin") {
              localStorage.setItem("access_token", response.data.Payload);
              localStorage.setItem("authUser", JSON.stringify(authUser));
              props.history.goBack();
            } else {
              setError(true);
              setMessage("Permission denied");
            }
          }
        })
        .catch((error) => {
          setIsLoading(false);
          if (error && error.response && error.response.data.Message) {
            setError(true);
            setMessage(error.response.data.Message);
          }
          console.log("error", error);
          console.log("error", error.response);
        });
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            error={error && !email}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            value={email}
            autoComplete="email"
            autoFocus={true}
            helperText={error ? "Email Required" : ""}
            onChange={(event) => handleEmail(event.target.value)}
          />
          <TextField
            error={error && !password}
            variant="outlined"
            required={true}
            margin="normal"
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            value={password}
            autoComplete="current-password"
            helperText={error ? "Password Required" : ""}
            onChange={(event) => handlePassword(event.target.value)}
          />

          {error && message && (
            <div style={{ margin: 16 }}>
              <Alert severity="error">{message} </Alert>
            </div>
          )}
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={() => handleSubmit()}
          >
            Sign In
          </Button>
          {isLoading ? (
            <Grid item xs={12}>
              <div className={classes.loader}>
                <CircularProgress color="secondary" />
              </div>
            </Grid>
          ) : null}
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
};

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },

  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: red[400],
    "&:hover": {
      backgroundColor: red[200],
    },
  },
  loader: {
    margin: 16,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
}));

export default withRouter(SignIn);
